import { Col, Row, Avatar, message } from 'antd'
import React, { useContext, useEffect, useState } from 'react'
import Img from "../image/shop/product-2.png";
import Header from "../component/header";
import { Rating } from '../component/Rating';
import avatar_1 from './../image/male.png';
import Product_Count from '../component/Product_Count';
import { MdOutlineShoppingBag } from "react-icons/md";
import Products_Review_Tabs from '../component/Products_Review_Tabs';
import Footer from '../component/Footer';
import { useParams } from 'react-router-dom';
import { UserDataContext } from '../context/User';
import Detail_Product_Slider from '../component/Product_Sliders/Detail_Product_Slider';
const Product_Details = () => {
    const { userData } = useContext(UserDataContext);
    const [products,setProducts]=useState([]);
    const isLoggedIn = userData?.id;
    const userTier = userData?.membershipTier?.key || "free"; // Assuming userData has a tier object with a key
  
    const [loading, setLoading] = useState(true);
    const [messageApi] = message.useMessage();
  
  const { id } = useParams();
      useEffect(() => {
          const fetchGallery = async () => {
            try {
              setLoading(true);
              const response = await fetch(`/api/products/fetch/${id}`, {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                },
              });
              const data = await response.json();
              console.log(data.data);
  
              if (data.success) {
                setProducts(data.data);
              } else {
                messageApi.error("Failed to load gallery");
              }
            } catch (error) {
              console.error("Fetch error:", error);
              messageApi.error("Error loading gallery");
            } finally {
              setLoading(false);
            }
          };
          fetchGallery();
        }, [messageApi]);

      const limitWords = (text, limit = 100) => {
  if (!text) return "";
  const words = text.split(" ");
  return words.length > limit
    ? words.slice(0, limit).join(" ") + "..."
    : text;
};
const allImages = products?.colors?.flatMap(color => color.images) || [];
  return (
    <div className="App">
      <Header isBlack={true}/>
    <section  className="extra-effort pt-[160px] px-[1rem]">
      <div className="container m-auto">
        <Row
          gutter={[24, 24]}
          align="middle"
          justify="center"
          className="overflow-hidden"
        >
        
           <Col xs={24} sm={24} md={12} lg={12} xl={12} >
            <div  className="mission-images ">
              <Detail_Product_Slider image={allImages}/>
              {/* <img
                src={Img}
                className="w-[80%] h-[70%] object-contain rounded-lg "
                alt="img"
              /> */}
            </div>
          </Col>

        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <div  className="text-start"> 
              <h2 className="text-[40px] xs:text-[30px] lg:text-[50px] font-cinzel text-start">
              {products.title}
              </h2>
              <p className="pb-5 text-[18px] text-[#000] text-start font-outfit ">
               {products.subtitle}
              </p>
              <hr  style={{height:"2px", background:"#000000"}}/>
              <p className="pb-5 text-[18px] text-[#000] text-start font-outfit mt-4">
                {limitWords(products.description, 50)}
              </p>
              <div>
                 <h2 className='font-cinzel text-[26px] mb-2'>
                  Product Highlights
                 </h2>
              <ul >
  <li className="pb-2 text-[18px] text-[#000] font-outfit">
    ✔️ Premium 100% Cotton – soft, breathable & durable
  </li>
  <li className="pb-2 text-[18px] text-[#000] font-outfit">
    ✔️ Minimalist design (embroidered-style print)
  </li>
  <li className="pb-2 text-[18px] text-[#000] font-outfit">
    ✔️ Lightweight & comfortable for all-day wear
  </li>
  <li className="pb-2 text-[18px] text-[#000] font-outfit">
    ✔️ Unisex fit – suitable for both men and women
  </li>
  <li className="pb-2 text-[18px] text-[#000] font-outfit">
    ✔️ Perfect for artist, painters, and art lovers
  </li>
  <li className="pb-2 text-[18px] text-[#000] font-outfit">
    ✔️ Machine-washable, fade-resistant print
  </li>
</ul>
 </div>
               <div>
                 <h2 className='font-cinzel text-[26px] m-2'>
                  Sizes
                 </h2>
                   <div className="flex flex-wrap gap-[15px]">
                          <button className="font-cinzel text-[20px] border border-black rounded-[25px] px-[0.8rem] py-[0.3rem]">
                              Small
                          </button>
                           <button className="font-cinzel text-[20px] border border-black rounded-[25px] px-[0.8rem] py-[0.3rem]">
                              Medium
                          </button>
                           <button className="font-cinzel text-[20px] border border-black rounded-[25px] px-[0.8rem] py-[0.3rem]">
                              Large
                          </button>
                           <button className="font-cinzel text-[20px] border border-black rounded-[25px] px-[0.8rem] py-[0.3rem]">
                             XL
                          </button>
                         
                   </div>
                 </div>
             <div className='flex flex-wrap item-center justify-start gap-[1rem] lg:gap-[4rem] mt-[2rem]'>
                 <div>
                    <h2 className='font-cinzel text-[40px]'>$28.99</h2>
                    <span className='font-cinzel text-[24px] text-black/50 line-through'>$30.00</span>
                 </div>
                 <div>
                    <div className='flex gap-[1rem] items-center justify-center'>
                    <Rating rating={4.5}/>
                     <span className='font-outfit text-[20px] text-[#000000]'>4.5 Start Reviews</span>
                    </div>
                   <div className='flex gap-[1rem] mt-[1rem] items-center justify-center'>
                    <Avatar.Group >
      <Avatar src="https://api.dicebear.com/7.x/miniavs/svg?seed=1" />
        <Avatar src={avatar_1} />
        <Avatar style={{ backgroundColor: '#87d068' }} >Z</Avatar>
      <Avatar style={{ backgroundColor: '#1677ff' }} >A</Avatar>
    </Avatar.Group>
    <span className='font-outfit text-[20px] text-[#000000]'>+10 Customer Reviews</span>
                    </div>
                 </div>
             </div>

             <div className='flex flex-wrap item-center justify-start gap-[1rem] lg:gap-[4rem] mt-[2rem]'>
                <Product_Count/>
                  <button
                className="flex items-center justify-center text-black font-outfit font-semibold px-6 py-3 rounded-full shadow-md 
             hover:opacity-90 transition-all duration-500 text-[16px]"
                style={{
                  background:
                    "linear-gradient(29deg, rgba(0,240,251,1) 0%, rgba(255,255,255,1) 50%, rgba(0,240,251,1) 100%)",
                  backgroundSize: "200% 200%",
                  backgroundPosition: "0% 50%",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundPosition = "100% 50%";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundPosition = "0% 50%";
                }}
              >
                
              <MdOutlineShoppingBag style={{fontSize:"24px"}}/>
              Add To Cart
              </button>
             </div>

            </div>
           </Col>
        </Row>
      <Products_Review_Tabs product={products}/>
      </div>

    </section>
    <Footer/>
    </div>
  )
}

export default Product_Details
